import React from 'react';
import Flower from './Flower';
import Leaves from './Leaves';
import InnerBranch from './InnerBranch';

const MainBranch = ({ 
  id, 
  direction, 
  branchNum, 
  leaves, 
  flowerId, 
  innerBranches,
  subBranch,
  visible = true,
  flowerVisible = true,
  leaf1Visible = true,
  leaf2Visible = true,
  leaf3Visible = true,
  getFlowerColor,
  getFlowerUtterance = () => undefined,
  isDynamic = false,
  trunkHeight,
  style
}) => {
  if (!visible) return null;
  
  const branchClass = isDynamic 
    ? `branch ${direction} dynamic` 
    : `branch branch${branchNum} ${direction}`;
  
  // Extract scale factor from style if it's a dynamic branch
  const scaleFactor = isDynamic && style ? style['--width-scale'] : 1;
  // if (isDynamic) {
  //   console.log(`→ Rendering MainBranch ${id}:`, {
  //     branchNum,
  //     direction,
  //     scaleFactor,
  //     width: style?.width,
  //     height: style?.height,
  //     visible
  //   });
  // }
  
  return (
    <div 
      className={branchClass}
      style={style}
      aria-hidden="true"
    >
      {/* Main branch leaves */}
      {leaf1Visible && (
        <div className={`leaf leaf1`} />
      )}
      {leaf2Visible && (
        <div className={`leaf leaf2`} />
      )}
      {leaf3Visible && (
        <div className={`leaf leaf3`} />
      )}
      
      {/* Main branch flower */}
      {flowerVisible && (
        <Flower
          flowerId={flowerId} 
          color={getFlowerColor(flowerId)} 
          utterance={getFlowerUtterance(flowerId)}
        />
      )}
      
      {/* Inner branches - pass scale factor */}
      {innerBranches && innerBranches.map((innerBranch) => (
        innerBranch.visible && (
          <InnerBranch
            key={innerBranch.id}
            {...innerBranch}
            getFlowerColor={getFlowerColor}
            getFlowerUtterance={getFlowerUtterance}
            scaleFactor={scaleFactor}
            parentBranchNum={branchNum}
            isDynamic={isDynamic}
          />
        )
      ))}
    </div>
  );
};

export default MainBranch;
